export default {
  computed: {
    playersStats() {
      if (!this.players) return null;
      return {
        total: this.players.length,
        participating: this.players.filter((p) => p.isParticipating).length,
        absent: this.players.filter((p) => !p.isParticipating).length,
      };
    },
  },
};
